import React from 'react';

const PrimaryButton = ({
  children,
  onClick,
  type = 'button',
  disabled = false,
  loading = false,
  className = '',
  ...rest
}) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled || loading}
    className={`h-[34px] px-[13px] bg-brandFill hover:bg-brandFillHover text-white rounded-lg text-xs font-medium flex items-center justify-center gap-1.5 transition-colors disabled:bg-fill disabled:hover:bg-fill disabled:text-ink-disabled disabled:shadow-none disabled:cursor-not-allowed shadow-control focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus ${className}`}
    {...rest}
  >
    {loading && (
      <span className="animate-spin h-3.5 w-3.5 border-2 border-current border-t-transparent rounded-full shrink-0" />
    )}
    {children}
  </button>
);

export default PrimaryButton;
